module.exports = __webpack_public_path__ + "static/media/userguide.dd01570b.pdf";